// istanbul ignore file

/*
  These functions are needed because the explorer content is contained
  within an iframe and certain methods e.g. matchMedia need to be called
  on the iframe's window/document. However, when components are not rendered
  within the explorer they need access to the global window/document.
*/

const getIframe = () => document.querySelector('#explorer-iframe');

export const getWindow = () => {
  const iframe = getIframe();
  return iframe ? iframe.contentWindow : window;
};

export const getDocument = () => {
  const iframe = getIframe();
  return iframe ? iframe.contentDocument : document;
};
